// extracted by mini-css-extract-plugin
export default {"container":"StatsBox_container__EmOSL","count":"StatsBox_count__4O2AO","title":"StatsBox_title__VFfKw"};